
export class Connection {
    start: string;
    end: string;

    
    constructor(_start: string, _end: string)
        {
        this.start = _start;
        this.end = _end;
        }
}

